// Client-side image resize + JPEG compression so leads stay <3MB total
// regardless of phone camera megapixels.
//
// Resizes to MAX_DIM longest side, encodes to JPEG quality 0.78, returns
// a base64 data URI string.

const MAX_DIM = 1280;
const QUALITY = 0.78;

export function compressImage(file) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type?.startsWith("image/")) {
      reject(new Error("Not an image"));
      return;
    }
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Read failed"));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error("Decode failed"));
      img.onload = () => {
        let { width, height } = img;
        const scale = Math.min(1, MAX_DIM / Math.max(width, height));
        width = Math.round(width * scale);
        height = Math.round(height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, width, height);
        const dataUrl = canvas.toDataURL("image/jpeg", QUALITY);
        resolve(dataUrl);
      };
      img.src = reader.result;
    };
    reader.readAsDataURL(file);
  });
}

export function dataUrlSizeKb(dataUrl) {
  // base64 chars are 6 bits each → bytes ≈ (length * 3) / 4
  const base64 = dataUrl.split(",")[1] || "";
  const bytes = (base64.length * 3) / 4;
  return Math.round(bytes / 1024);
}
